module.exports = __webpack_public_path__ + "static/media/Einzelstunden02.ef4bc2d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Einzelstunden02.jpg
// module id = 338
// module chunks = 0